import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import CustomerSalesRewardForm from 'Modules/customerSalesReward/customerSalesRewardForm'
import { clearToast } from 'Reducers/customerSalesRewardReducer'
import { STATUS, getCustomerSalesRewardDetails } from 'Reducers/actions/customerSalesRewardActions'
import { connect } from 'react-redux'

class CustomerSalesRewardEdit extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    this.props.getCustomerSalesRewardDetails(this.props.match.params.CustomerSalesRewardID)
  }
  componentDidUpdate() {
    if (this.props.loadingState === STATUS.FETCHING_CUSTOMER_SALES_REWARD_DETAILS_FAILED) {
      toast.error('FETCHING CUSTOMER_SALES_REWARD FAILED', {
        autoClose: 7500,
        onClose: () => {
          this.props.clearToast()
        }
      })
      this.props.clearToast()
    }

    if (this.props.loadingState === STATUS.CUSTOMER_SALES_REWARD_FAILED) {
      toast.error('UPDATE CUSTOMER_SALES_REWARD FAILED', {
        autoClose: 3000,
        onClose: () => {
          this.props.clearToast()
        }
      })
      this.props.clearToast()
    }
    if (this.props.loadingState === STATUS.CUSTOMER_SALES_REWARD_SUCCESS) {
      toast.success('UPDATE CUSTOMER_SALES_REWARD SUCCESSFUL', {
        autoClose: 3000,
        onClose: () => {
          this.props.clearToast()
        }
      })
      this.props.clearToast(STATUS.IS_REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <CustomerSalesRewardForm {...this.props} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ loadingState: state.customerSalesReward.loadingState })

export default connect(mapStateToProps, { getCustomerSalesRewardDetails, clearToast })(CustomerSalesRewardEdit)
